/**
 * Check if an object has any of the provided keys.
 *
 * @param {Object} object The object to check for keys.
 * @param {Array} keys The keys to search in the object.
 *
 * @returns {boolean} True when the object contains any of the provided keys.
 */
export default (object, keys) => Object.keys(object).some((key) => keys.includes(key));
